import { openBlock as e, createElementBlock as t, createElementVNode as a } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ a("path", { d: "M14.713 7.693a.75.75 0 0 0 .817-.163l1.822-1.822a.75.75 0 0 0 .083.085 8.25 8.25 0 0 1 .905 11.486L6.72 5.66a8.25 8.25 0 0 1 3.396-1.692.75.75 0 1 0-.342-1.46 9.75 9.75 0 0 0-4.117 2.088L4.53 3.47a.75.75 0 1 0-1.06 1.06l1.126 1.127a9.75 9.75 0 0 0 .995 13.691L4.47 20.47A.75.75 0 0 0 5 21.75h4a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-1.28-.53l-1.815 1.815A8.25 8.25 0 0 1 5.66 6.72l11.62 11.62a8.25 8.25 0 0 1-4.991 1.905.75.75 0 1 0 .052 1.5 9.75 9.75 0 0 0 6.003-2.34l1.126 1.125a.75.75 0 1 0 1.06-1.06l-1.126-1.126a9.748 9.748 0 0 0-.981-13.68l-.014-.012L19.53 3.53A.75.75 0 0 0 19 2.25h-4a.75.75 0 0 0-.75.75v4a.75.75 0 0 0 .463.693Z" }, null, -1), l = [
  n
];
function c(r, s) {
  return e(), t("svg", o, [...l]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
